import { render, staticRenderFns } from "./TabRejected.vue?vue&type=template&id=c2ada0ca&"
import script from "./TabRejected.vue?vue&type=script&lang=js&"
export * from "./TabRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports